import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
// Third party packaged
import { MatDialog } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { finalize, take } from 'rxjs/operators';
// Custom packages
import { AuthService } from 'src/app/modules/auth/auth.service';
import { ConfirmDialogComponent } from 'src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component';
import { ConfigService } from 'src/app/shared/services/config.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import { ThemeService } from 'src/app/shared/services/theme.service';
var ForgotPasswordComponent = /** @class */ (function () {
    // END - Add property form
    /**
     * Class constructor
     */
    function ForgotPasswordComponent(themeService, authService, toastrService, translateService, router, activatedRoute, helperService, configService, dialog) {
        this.themeService = themeService;
        this.authService = authService;
        this.toastrService = toastrService;
        this.translateService = translateService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.helperService = helperService;
        this.configService = configService;
        this.dialog = dialog;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - Add property form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant('auth.forgotPassword.form.submitButtonText'),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: 'primary',
            spinnerColor: 'primary',
            fullWidth: false,
            disabled: false,
            mode: 'indeterminate',
            buttonIcon: {
                fontSet: 'fal',
                fontIcon: 'fa-arrow-right',
                inline: true,
            },
        };
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    ForgotPasswordComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Subscribe to current lang and init component
        this.lang = this.translateService.currentLang;
        if (this.activatedRoute.params) {
            this.subscriptions.push(this.activatedRoute.params.subscribe(function (res) {
                if (res) {
                    if (res.lang) {
                        _this.lang = res.lang;
                    }
                    _this.handleRouteParamsChange();
                }
            }, function (err) {
                // if we came here users with given userId do not exist
                _this.router.navigate([_this.lang, 'errors', '404']);
            }));
        }
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    ForgotPasswordComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Init component
     */
    ForgotPasswordComponent.prototype.handleRouteParamsChange = function () {
        var _this = this;
        // Set page title
        this.themeService.setPageTitle(this.translateService.instant('auth.forgotPassword.pageTitle'));
        // Prevent form fields to be rendered twice on language change
        this.fields = [];
        // Initialize form
        this.initForm();
        // Set correct button text based on current language
        this.formBtnOptions.text = this.translateService.instant('auth.forgotPassword.form.submitButtonText');
        // Check if user is already logged in with authService.
        // If so, redirect him to home
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (user) {
            if (user) {
                _this.loggedUser = user;
                _this.router.navigate([_this.lang, 'app']);
            }
        }));
        // Check if user is logged in with cookies
        // data. If so, redirect him
        this.subscriptions.push(this.authService.checkLogin().subscribe(function (res) {
            if (res.status) {
                // User already logged, redirect him to home
                _this.router.navigate([_this.lang, 'app']);
            }
        }));
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    ForgotPasswordComponent.prototype.initForm = function () {
        // Set model
        this.model = {
            email: '',
        };
        // Set fields
        this.fields = tslib_1.__spread(this.fields, [
            {
                fieldGroupClassName: 'row',
                fieldGroup: [
                    {
                        className: 'col-12',
                        type: 'input',
                        key: 'email',
                        templateOptions: {
                            label: this.translateService.instant('auth.login.form.email.label'),
                            placeholder: this.translateService.instant('auth.login.form.email.placeholder'),
                            required: true,
                            maxLength: 320,
                            type: 'email',
                            pattern: this.configService.emailPattern,
                        },
                    },
                ],
            },
        ]);
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    ForgotPasswordComponent.prototype.onFormSubmit = function (model) {
        var _this = this;
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            this.toastrService.error(this.translateService.instant('common.errors.form_is_invalid'));
            return;
        }
        // Activate submit button loading status
        this.formBtnOptions.active = true;
        this.subscriptions.push(this.authService.recoverPassword(model.email)
            .pipe(finalize(function () { return _this.formBtnOptions.active = false; }))
            .subscribe(function (res) {
            if (res.status) {
                var dialogRef = _this.dialog.open(ConfirmDialogComponent, {
                    data: {
                        title: _this.translateService.instant('dialogs.resetPassword.title'),
                        message: _this.translateService.instant('dialogs.resetPassword.message'),
                        btnOkText: _this.translateService.instant('dialogs.resetPassword.login'),
                        btnCancelText: _this.translateService.instant('common.cta.close'),
                    },
                    width: '500px',
                    disableClose: true
                });
                // Subscribe to dialog result (only for 1 emit thanks to "take()")
                dialogRef.beforeClosed()
                    .pipe(take(1))
                    .subscribe(function (res2) {
                    if (res2) {
                        // User hit confirm button. We can redirect him
                        _this.router.navigate([_this.lang, 'auth', 'login']);
                    }
                });
                return;
            }
            // Check if back-end is up and is running
            _this.toastrService.error(_this.translateService.instant('common.errors.server_down'));
            return;
        }, function (err) {
            // Choose one of the following error handling method.
            // 1) First one show a message right under the form fields
            //    (if the form is properly setted)
            // 2) Second one is used to show a mat-error under each field
            //    in the dynamic form (is meant to be used only in dynamicForm)
            // 3) Third one show toastr notifications for each error
            // 4) Fourth one is used to show mat-error under each field
            //    in the ngx-formly form (is mean to be used only with ngx-formly)
            // this.helperService.handleFormError(form, err);
            // this.helperService.handleDynamicFormError(form, err);
            // this.helperService.handleError(err);
            _this.helperService.handleFormlyError(_this.form, err);
        }));
    };
    return ForgotPasswordComponent;
}());
export { ForgotPasswordComponent };
